module.exports = __webpack_public_path__ + "static/media/mobileb1.7f6d93d2.jpg";